import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';


const importInvitationRoutes = () => import(/* webpackChunkName: "invitations" */ './containers/InvitationContainer');

const InvitationRoutes = ({ match }) => (
  <BundleRoute
    load={importInvitationRoutes}
    path={`${match.url}/:invitationToken`}
  />
);

InvitationRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default InvitationRoutes;
